import { useParams, Link, Navigate } from "react-router-dom";
import { LEGAL_PAGES } from "@/lib/legal";

const LINKS = [
  { slug: "privacy", label: "Privacy Policy" },
  { slug: "terms", label: "Terms & Conditions" },
  { slug: "returns", label: "Returns & Refunds" },
  { slug: "course-terms", label: "Course Terms" },
  { slug: "trade-terms", label: "Trade Terms" },
];

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];
  if (!page) return <Navigate to="/privacy" replace />;

  return (
    <div data-testid={`page-legal-${slug}`} className="pt-32 pb-24">
      <div className="mx-auto max-w-[1100px] px-6 sm:px-10">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* Sidebar */}
          <aside className="lg:col-span-3">
            <div className="overline mb-4">Legal</div>
            <nav className="space-y-1">
              {LINKS.map((l) => (
                <Link
                  key={l.slug}
                  to={`/legal/${l.slug}`}
                  data-testid={`legal-nav-${l.slug}`}
                  className={`block rounded-2xl px-4 py-2.5 text-sm transition-colors ${
                    slug === l.slug
                      ? "bg-[hsl(var(--onyx))] text-[hsl(var(--cream))]"
                      : "text-[hsl(var(--onyx)/0.7)] hover:bg-blush/50"
                  }`}
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </aside>

          {/* Body */}
          <article className="lg:col-span-9">
            <div className="overline">{page.updated}</div>
            <h1 className="font-display text-4xl sm:text-5xl mt-3 tracking-tight text-balance">{page.title}</h1>
            <p className="mt-3 text-[hsl(var(--onyx)/0.65)]">{page.subtitle}</p>

            <div className="mt-10 space-y-8">
              {page.sections.map((s) => (
                <section key={s.h}>
                  <h2 className="font-display text-xl leading-tight text-[hsl(var(--burgundy))]">{s.h}</h2>
                  <p className="mt-3 text-[hsl(var(--onyx)/0.75)] leading-relaxed whitespace-pre-line">{s.p}</p>
                </section>
              ))}
            </div>

            <div className="mt-14 rounded-2xl bg-blush/40 border border-[hsl(var(--onyx)/0.06)] p-6 text-xs text-[hsl(var(--onyx)/0.55)] leading-relaxed">
              This document sets out the terms between you and Malek Dridi Hair &amp; Beauty (trading as NøoksPro). If any part is unclear, please email hello@malekdridihairandbeauty.com and we'll be happy to explain.
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}
